import React, { useState, useEffect } from "react";
import {
  UseFormRegister,
  FieldErrors,
  Control,
  useWatch,
  Controller,
} from "react-hook-form";
import Input from "../../../components/FormInputs";
import FormTitle from "../../../components/FormTitle";
import PhoneInput from "../../../components/phoneinput";
import CustomDropDown from "../../../components/Dropdown/CustomDropDown";
import { ApiService } from "../../../service/api.service";
import { MASTER_URL, OPERTIONS_URL } from "../../../common/common";
import CustomModalDropDown from "../../../components/Dropdown/CustomModalDropDown";
import { ClientDetailsProps } from "../../../service/interfaces/Components";

const ClientDetailes: React.FC<ClientDetailsProps> = ({
  setclientDetailData,
  errors,
  register,
  control,
  setValue,
  clientDetail,
}) => {
  const apiService1 = new ApiService();
  const entityId = localStorage.getItem("entity_id");
  const [ClientId, setClientId] = useState<any>([]);
  const [filteredCompanies, setFilteredCompanies] = useState<any>([]);
  const [Executive, setExecutive] = useState<any>([]);
  const [executiveData, setExecutiveData] = useState<any>([]);

  // Helper function to get error for a specific field
  const getFieldError = (fieldName: string) => {
    return (errors?.clientDetail as any)?.[fieldName]?.message || "";
  };

  // Helper function to check if field has error
  const hasFieldError = (fieldName: string) => {
    return !!(errors?.clientDetail as any)?.[fieldName];
  };

  // const getMasterData = async () => {
  //   const response: any = await apiService1.getApi(
  //     `${OPERTIONS_URL}/client/get-all-route?entityId=${entityId}`
  //   );
  //   if (response.status === "200") {
  //     if (response.body) {
  //       const formattedOptions = response.body.data?.map((item: any) => ({
  //         value: item.clientId,
  //         label: item.firstName,
  //         email: item.emailId,
  //         address: `${item.address1}+""+${item.address2}`,
  //         contactNumber: item.contactNumber,
  //       }));
  //       setClientId(formattedOptions);
  //       setFilteredCompanies(formattedOptions);
  //     }
  //     if (response.body["Container Size"]) {
  //       const formattedOptions = response.body["Container Size"].map(
  //         (item: any) => ({
  //           value: item.metaId,
  //           label: item.value,
  //         })
  //       );
  //       setExecutive(formattedOptions);
  //     }
  //   }
  // };

  const fetchExecutives = async (companyId: string) => {
    try {
      const response: any = await apiService1.getApi(
        `${OPERTIONS_URL}/executive/details-route?clientId=${companyId}&entityId=${entityId}`
      );
      if (response.body.length === 1) {
        setValue(`clientDetail.executive`, response.body[0].executiveId);
        setValue(`clientDetail.emailId`, response.body[0].emailId);
        setValue(`clientDetail.contactNumber`, response.body[0].phoneNumber);
      }
      if (response.status === "200" && response.body) {
        const formattedExecutives = response.body.map((item: any) => ({
          value: item.executiveId,
          label: `${item.firstName} ${item.lastName}`,
          emailId: item.emailId,
          phoneNumber: item.phoneNumber,
        }));

        setExecutiveData(formattedExecutives);
      }
    } catch (error) {
      console.error("Failed to fetch executives", error);
    }
  };

  // Watch all relevant fields
  const watchedFields = useWatch({
    control,
    name: [
      "clientDetail.clientId",
      "clientDetail.executive",
      "clientDetail.contactNumber",
      "clientDetail.emailId",
    ],
  });

  const [clientId, executive, contactNumber, emailId] = watchedFields;
  useEffect(() => {
    if (executive && executiveData.length > 0) {
      const selectedExecutive = executiveData.find(
        (exec: any) => exec.value === executive
      );
      if (selectedExecutive) {
        setValue("clientDetail.emailId", selectedExecutive.emailId);
        setValue("clientDetail.contactNumber", selectedExecutive.phoneNumber);
      }
    }
  }, [executive, executiveData, setValue]);

  // useEffect(() => {
  //   const clientDetailObject = {
  //     clientId: clientId || "",
  //     executive: executive || "",
  //     contactNumber: contactNumber || "",
  //     countryCode: "+91",
  //     emailId: emailId || "",
  //   };

  //   setclientDetailData(clientDetailObject);
  // }, [watchedFields]);

  // useEffect(() => {
  //   getMasterData();
  // }, []);

  useEffect(() => {
    if (clientId) {
      const selectedCompany = ClientId.find(
        (company: any) => company.label === clientId
      );
      // if (selectedCompany) {
      //   fetchExecutives(selectedCompany.value);
      // }
    }
  }, [clientId]);
  return (
    <div className="bg-white p-4 rounded-[20px]">
      <div className="flex items-center justify-between">
        <FormTitle title="Client Details" />
      </div>
      <div className="">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 p-6 bg-white ">
          {/* Company Name */}
          <div className="flex flex-col">
            <CustomModalDropDown
              label="Company Name"
              name="clientDetail.clientId"
              defaultValue={clientDetail.clientId || ""}
              endpoint="client/get-all-route"
              register={register}
              fetchExecutives={fetchExecutives}
              setValue={(name: any, value: any) => {
                setValue(name, value);
                fetchExecutives(value);
              }}
              errors={
                hasFieldError("clientId")
                  ? {
                      "clientDetail.clientId": {
                        message: getFieldError("clientId"),
                      },
                    }
                  : {}
              }
            />
          </div>

          {/* Executive Name */}
          <div className="flex flex-col">
            {/* <CustomDropDown
          label="Executive Name"
          name="clientDetail.executive"
          options={executiveData || []}
          register={register}
          errors={
            hasFieldError("executive")
              ? { "clientDetail.executive": { message: getFieldError("executive") } }
              : {}
          }
          className="w-full"
        /> */}
            <Controller
              name={`clientDetail.executive`}
              control={control}
              defaultValue={clientDetail.executive || ""}
              render={({ field }) => (
                <CustomDropDown
                  label="Executive Name"
                  name={`clientDetail.executive`}
                  options={executiveData}
                  register={register}
                  // errors={errors}
                  errors={
                    hasFieldError("executive")
                      ? {
                          "clientDetail.executive": {
                            message: getFieldError("executive"),
                          },
                        }
                      : {}
                  }
                  defaultValue={field.value || ""}
                  onChange={(value) => field.onChange(value)}
                />
              )}
            />
          </div>

          {/* Phone Number */}
          <div className="flex flex-col">
            <PhoneInput
              label="Phone Number"
              name="clientDetail.contactNumber"
              defaultCountry="IN"
              defaultValue={clientDetail.contactNumber || ""}
              type="tel"
              maxLength={10}
              placeholder="Enter your phone number"
              control={control}
              errors={
                hasFieldError("contactNumber")
                  ? {
                      "clientDetail.contactNumber": {
                        message: getFieldError("contactNumber"),
                      },
                    }
                  : {}
              }
            />
          </div>

          {/* Mail ID */}
          <div className="flex flex-col">
            <Input
              label="Mail ID"
              name="clientDetail.emailId"
              register={register}
              placeholder="Enter Mail ID"
              defaultValue={clientDetail.emailId || ""}
              errors={
                hasFieldError("emailId")
                  ? {
                      "clientDetail.emailId": {
                        message: getFieldError("emailId"),
                      },
                    }
                  : {}
              }
              className="w-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientDetailes;